import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const PlayerType = React.memo(({
  t, currentType, gameState, largePlayer, sittingOut,
}) => (
  <Fragment>
    {sittingOut ? (
      <div className="player-type-wrapper">
        <div className="player-type-mazais">{t('game:dealer')}</div>
      </div>
    ) : (
      <Fragment>
        {currentType !== 'galdins' && (gameState === 'play'
        || gameState === 'burry') && (
        <div className="player-type-wrapper">
          <Fragment>
            {largePlayer ? (
              <Fragment>
                {currentType === 'parasta' && (
                <div className="player-type-lielais">{t('game:large')}</div>
                )}
                {currentType === 'zole' && (
                <div className="player-type-lielais">{t('game:zole')}</div>
                )}
                {currentType === 'maza' && (
                <div className="player-type-lielais">{t('game:smallZole')}</div>
                )}
              </Fragment>
            ) : (
              <div className="player-type-mazais">{t('game:small')}</div>
            )}
          </Fragment>
        </div>
        )}
      </Fragment>
    )}
  </Fragment>
));

PlayerType.propTypes = {
  t: PropTypes.func.isRequired,
  currentType: PropTypes.string,
  gameState: PropTypes.string,
  largePlayer: PropTypes.bool,
  sittingOut: PropTypes.string,
};

PlayerType.defaultProps = {
  currentType: null,
  gameState: null,
  largePlayer: false,
  sittingOut: null,
};

export default PlayerType;
